/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService
 */
import * as References from './PlaylistAssignmentsChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#createPlaylistAssignments
 */
export const CREATE_PLAYLIST_ASSIGNMENTS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_createPlaylistAssignments';
export const CREATE_PLAYLIST_ASSIGNMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CREATE_PLAYLIST_ASSIGNMENTS_QUERY_FIELD_NAME,
  args: ['playlistId', 'targetPortalId', 'assigneeUserIds', 'teamIds', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPlaylistAssignmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#assignPlaylist
 */
export const ASSIGN_PLAYLIST_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_assignPlaylist';
export const ASSIGN_PLAYLIST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASSIGN_PLAYLIST_MUTATION_FIELD_NAME,
  args: ['playlistId', 'targetPortalId', 'assigneeUserIds', 'teamIds', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.assignPlaylistRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#getPlaylistAssignmentsByIds
 */
export const GET_PLAYLIST_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_getPlaylistAssignmentsByIds';
export const GET_PLAYLIST_ASSIGNMENTS_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME,
  args: ['assignmentId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPlaylistAssignmentsByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#updatePlaylistAssignment
 */
export const UPDATE_PLAYLIST_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_updatePlaylistAssignment';
export const UPDATE_PLAYLIST_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PLAYLIST_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['assignmentIds', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updatePlaylistAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#deletePlaylistAssignment
 */
export const DELETE_PLAYLIST_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_deletePlaylistAssignment';
export const DELETE_PLAYLIST_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PLAYLIST_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['playlistAssignmentId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.deletePlaylistAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['playlistId', 'targetPortalId', 'query', 'assignedByRequestingUser', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService#searchAggregation
 */
export const SEARCH_AGGREGATION_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PlaylistAssignmentsChirpService_searchAggregation';
export const SEARCH_AGGREGATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_AGGREGATION_QUERY_FIELD_NAME,
  args: ['playlistId', 'query', 'assignedByRequestingUser', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.searchAggregationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});